//智能物联路由配置
export const smartConnectionRouter = [
  {
    path: '/service/smartConnection/device/list',
    name: 'DeviceManager',
    component: () => import('@/views/service/serviceProvider/smartConnection/DeviceManager'),
    meta: {
      title: '设备管理',
      keepAlive: true
    }
  },
  {
    path: '/service/smartConnection/vm/device/list',
    name: 'VmDeviceList',
    component: () => import('@/views/service/serviceProvider/smartConnection/vendingMachine/VmDeviceList'),
    meta: {
      title: '设备列表',
      keepAlive: true
    }
  },
  {
    path: '/service/smartConnection/vm/product/list',
    name: 'VmProductManager',
    component: () => import('@/views/service/serviceProvider/smartConnection/vendingMachine/VmProductManager'),
    meta: {
      title: '商品管理',
      keepAlive: true
    }
  },
  {
    path: '/service/smartConnection/vm/product/editor',
    name: 'VmProductEditor',
    component: () => import('@/views/service/serviceProvider/smartConnection/vendingMachine/VmProductEditor'),
    meta: {
      title: '编辑管理',
      keepAlive: false
    }
  },
  {
    path: '/service/smartConnection/cl/device/list',
    name: 'ClDeviceList',
    component: () => import('@/views/service/serviceProvider/smartConnection/chargingLine/ClDeviceList'),
    meta: {
      title: '设备列表',
      keepAlive: true
    }
  },
  {
    path: '/service/smartConnection/channel/list',
    name: 'ChannelManager',
    component: () => import('@/views/service/serviceProvider/smartConnection/ChannelManager'),
    meta: {
      title: '渠道管理',
      keepAlive: true
    }
  },
  {
    path: '/service/smartConnection/order/list',
    name: 'OrderManager',
    component: () => import('@/views/service/serviceProvider/smartConnection/OrderManager'),
    meta: {
      title: '订单管理',
      keepAlive: true
    }
  },
  {
    path: '/service/smartConnection/statistics',
    name: 'Statistics',
    component: () => import('@/views/service/serviceProvider/smartConnection/Statistics'),
    meta: {
      title: '数据统计',
      keepAlive: true
    }
  }
]